import { motion, AnimatePresence } from 'motion/react';
import type React from 'react';

type OwnProps = {
  children: React.ReactNode;
  className?: string;
  show: boolean;
};

export const OPEN_ANIMATION_DURATION_SECONDS = 0.5;
export default function AnimateHeight({ children, className, show }: OwnProps) {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          initial={{ height: 0 }}
          animate={{ height: 'auto' }}
          exit={{ height: 0 }}
          transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }}
          style={{ overflow: 'hidden' }}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
